import ActivityPlans from 'components/activity-plans'
import StandaloneHeader from 'components/page-header/standalone-header'
import { gtmEvent } from 'lib/gtm'
import { useEffect } from 'react'

const PublicActivityPlansPage = () => {
  useEffect(() => {
    gtmEvent({
      event: 'activities-click',
      activitiesCategory: 'coach-activities',
      activitiesAction: 'stages-loaded',
      activitiesLabel: 'stages-loaded',
    })
  }, [])

  return (
    <>
      <StandaloneHeader title="Activity Plans" />
      <ActivityPlans />
    </>
  )
}

export default PublicActivityPlansPage
